module.exports = __webpack_public_path__ + "img/strike.bd4b7d9f.svg";